import { ParsedContent } from '@entities/TextMaterialBlock/types'

import { parseJson } from '@shared/uttils/parseJson'

import Gallery from './Gallery'
import Header from './Header'
import Image from './Image'
import List from './List'
import Paragraph from './Paragraph'
import ProductList, { ProductListInfo } from './ProductList'

import styles from './styles.module.scss'


type TextMaterialBlockProps = {
  block: string | null | undefined;
};

export default function TextMaterialBlock (props: TextMaterialBlockProps) {
  const { block } = props
  const currentContent = parseJson<ParsedContent>(block)


  if (!currentContent?.blocks?.length) {
    return null
  }

  return (
    <>
      {currentContent.blocks.map((item) => {
        switch (item.type) {
        case 'paragraph':
          return (
            <Paragraph
              key={item.id}
              className={styles.paragraph}
              data={item.data.text}
            />
          )
        case 'header':
          return (
            <Header
              id={item.id}
              key={item.id}
              className={styles.header}
              data={item.data.text}
              level={item.data.level}
            />
          )
        case 'image':
          return (
            <Image
              key={item.id}
              className={styles.image}
              data={item.data.file?.url}
            />
          )
        case 'list':
          return (
            <List
              key={item.id}
              className={styles.list}
              data={item.data.items}
              type={item.data.style}
            />
          )
        case 'productList':
          return (
            <ProductList
              key={item.id}
              className={styles.productList}
              data={item.data as ProductListInfo}
            />
          )
        case 'gallery':
          return (
            <Gallery
              key={item.id}
              className={styles.gallery}
              data={{
                files: item.data.files
              }}
            />
          )
        default:
          return null
        }
      })}
    </>
  )
}
